<div class="process-details-wrap" *ngIf="currentProcess; else loaderStub">
  <div class="main-toolbar mat-elevation-z2 top-page-controls">
    <div class="navigate-back">
      <div class="arrow-back" (click)="closeDetails()">
        <mat-icon>arrow_back</mat-icon>
      </div>
      <div class="separator"></div>
    </div>
    <div class="main-toolbar-content">
      <div class="title-place" i18n>
        <span>{{ "sources.scheduling.processingHistory.processId" | translate }} {{ ": " + this.data.id }}</span>
      </div>
      <div class="button-controls">
        <button *ngIf="isCurrentProcessInProgress" mat-button type="button" color="black"
                (click)="onCancelProcessInProgress()">
          <mat-icon>close</mat-icon>
          {{ "system.cancel" | translate }}
        </button>
        <button *ngIf="isCurrentProcessInProgress" (click)="onUpdateProcess()" mat-raised-button color="primary">
          <img class="update-img" src="../../../../../assets/img/icons/update.png" alt="" />
          <span>{{ "system.refresh" | translate }}</span>
        </button>
      </div>
    </div>
  </div>

  <div class="details-content">
    <div class="content">
      <div class="process-details-content" *ngIf="currentProcess">
        <div class="process-details-item">
          <label for="data-source-id">
            {{ "all-reports.data-processing.table.columns.dataSourceIdentifier" | translate }}
          </label>
          <p class="data-source-id">
            <a id="data-source-id" target="_blank" [routerLink]="getSourceConfigLink()">
              {{ currentProcess.DataSourceSlug }}
            </a>
          </p>
        </div>

        <div class="process-details-item">
          <label for="start-time-utc">
            {{ "sources.processingDetails.columns.startTimeUTC" | translate }}
          </label>
          <p id="start-time-utc">{{ currentProcess.StartDateUtc | date: "YYYY-MM-d hh:mm:ss" }}</p>
        </div>

        <div class="process-details-item" *ngIf="currentProcess.EndDateUtc">
          <label for="end-time-utc">
            {{ "sources.processingDetails.columns.endTimeUTC" | translate }}
          </label>
          <p id="end-time-utc">{{ currentProcess.EndDateUtc | date: "YYYY-MM-d hh:mm:ss" }}</p>
        </div>

        <div class="process-details-item">
          <label for="duration">
            {{ "all-reports.data-processing.table.columns.duration" | translate }}
          </label>
          <p id="duration">{{ getDuration() }}</p>
        </div>

        <div class="process-details-item">
          <label for="status">
            {{ "all-reports.data-processing.table.columns.status" | translate }}
          </label>
          <p id="status" class="status">
            <mee-process-status [currentProcessStatus]="currentProcess.Status"></mee-process-status>
          </p>
        </div>

        <div class="process-details-item">
          <label for="progress">
            {{ "sources.scheduling.tableOftenColumns.percent" | translate }}
          </label>
          <p id="progress">{{ getProgress() }}</p>
        </div>

        <div class="process-details-item">
          <label for="initiator-name">
            {{ "sources.processingDetails.columns.initializedBy" | translate }}
          </label>
          <p id="initiator-name">{{ currentProcess.InitiatorName }}</p>
        </div>

        <div class="process-details-item">
          <label for="data-source-type">
            {{ "sources.processingDetails.columns.type" | translate }}
          </label>
          <p id="data-source-type">{{ getDataSourceType() }}</p>
        </div>
      </div>
    </div>

    <mee-process-layers-table [processLayers]="processLayers"></mee-process-layers-table>
  </div>
</div>

<ng-template #loaderStub>
  <div class="loader-stub">
    <mat-spinner [strokeWidth]="4"></mat-spinner>
  </div>
</ng-template>
